export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/green-bullet.d47b6370.svg","height":12,"width":9};